
export default {
  /**
   * Prefixes the cookie name
   */
  _prefix: 'ota',

  /**
   * Max Age of a cookie (in days)
   */
  _maxAge: 7,

  /**
   * Same site setting
   */
  _sameSite: 'lax',

  // Getters
  get prefix () {
    return this._prefix + '-'
  },

  get maxAge () {
    return 60 * 60 * 24 * this._maxAge
  },

  get sameSite () {
    return ['strict', 'lax', 'none'].includes(this._sameSite) ? this._sameSite : 'lax'
  }
}
